export const API_BASE_URL_ENV = () => {
	return "https://back.vr-premium-studio.store/api";
};

export const GET_AUTH_USER = () => JSON.parse(localStorage.getItem("vr_auth"));

export const REACT_APP_GOOGLE_MAP_KEY =
	"AIzaSyASXo08NgXUS8ubi496rX9lSc6t_XCSWzs";

export const getLang = () => {
	return localStorage.getItem("vr_lang");
};

export const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
